export var createFaqFilter = function (group, limit) {
    var _a, _b;
    if (limit === void 0) { limit = 0; }
    return {
        productCode: (_a = group.supportPageUrl) === null || _a === void 0 ? void 0 : _a.substring(((_b = group.supportPageUrl) === null || _b === void 0 ? void 0 : _b.lastIndexOf('/')) + 1),
        productSku: group.sku,
        top: limit,
    };
};
